define.alias("shared/components/shared/ui/navigation-arrows", "auth/components/shared/ui/navigation-arrows");